import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { siteConfig } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-primary py-12">
      <div className="px-6 lg:px-12 xl:px-20">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8">
          {/* Logo & Description */}
          <div className="max-w-sm">
            <img
              src={siteConfig.logoDark}
              alt={siteConfig.name}
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-text-secondary">
              Building websites and client portals for hair & beauty businesses.
              See the value before you pay.
            </p>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row gap-6">
            <a
              href={`tel:${siteConfig.phone}`}
              className="flex items-center gap-2 text-text-secondary hover:text-text-primary transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm">{siteConfig.phone}</span>
            </a>
            <a
              href={`mailto:${siteConfig.email}`}
              className="flex items-center gap-2 text-text-secondary hover:text-text-primary transition-colors"
            >
              <Mail className="w-4 h-4" />
              <span className="text-sm">{siteConfig.email}</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border-light flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-text-light">
            © {currentYear} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-sm text-text-light hover:text-text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-sm text-text-light hover:text-text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
